import { useQuery } from "@tanstack/react-query";
import { Col, Popover, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { FaCircleUser } from "react-icons/fa6";
import { HiOutlineHome } from "react-icons/hi";
import { MdKeyboardArrowDown } from "react-icons/md";
import { PiCheckCircleDuotone } from "react-icons/pi";
import { Link, useLocation, useParams } from "react-router-dom";
import {
  fetchUserProfile,
  getProjectInfoById,
  getUserByRole,
} from "../../api/apiCallManager";
import {
  GET_LOCAL_STORAGE,
  LOCAL_STORAGE_KEY,
  SET_LOCAL_STORAGE,
} from "../../helpers/localStorage";
import { LOGGER } from "../../helpers/logger";
import { RE_DIRECT_TO } from "../../helpers/redirectHelper";
import { removeUnderscore } from "../../helpers/removeUnderScore";
import {
  FL,
  ML,
  PA,
  preDefinedRolesJsonList,
} from "../../pages/router/AddRoutesJson";
import useProfileDataStore from "../../zustand/store/profileDataStore";
import useRolesListStore from "../../zustand/store/roleListStore";
import useProjectInfoQuery from "../hooks/useProjectInfoQuery";
import { useProjectInfoStore } from "./../../zustand/store/projectInfoStore";
import "./navbar.scss";
import Notification from "./Notification";
function Navbar() {
  const [open, setOpen] = useState(false);
  const [filteredRolesList, setFilteredRolesList] = useState([]);
  const { rolesList, setRolesList } = useRolesListStore();
  const [profilePopoverOpen, setProfilePopoverOpen] = useState(false);
  const [isShowFullLoader, setIsShowFullLoader] = useState(false);
  const {
    data: userProfileData,
    error,
    isLoading,
  } = useQuery({ queryKey: ["userProfileDetail"], queryFn: fetchUserProfile });
  const { setProjectInfoZustandState, projectInfoZustandState } =
    useProjectInfoStore();

  const setUserProfile = useProfileDataStore((state) => state.setUserProfile);
  const [pageTitle, setPageTitle] = useState("");

  const location = useLocation();
  const { id } = useParams();
  const {
    data: projectInfoData,
    error: projectInfoErro,
    isLoading: projectInfoLoading,
  } = useProjectInfoQuery(id, getProjectInfoById);
  useEffect(() => {
    if (projectInfoData) {
      setProjectInfoZustandState(projectInfoData); // Update Zustand state
    }
  }, [projectInfoData]);
  const getPageTitle = (route) => {
    if (route.startsWith("/preview-fl-project/")) {
      return `Federated Learning Project`;
    } else if (route.startsWith("/ml-project")) {
      return "Machine Learning Project";
    } else if (route.startsWith("/fl-project")) {
      return "Federated Learning Project";
    } else if (route.startsWith("/create-fl-project")) {
      return "Create Federated Learning Project";
    } else if (route.startsWith("/manage-role")) {
      return "Manage Roles";
    } else if (route.startsWith("/manage-clients")) {
      return "Manage Clients";
    } else {
      return route.split("-").join(" ").split("/").filter(Boolean).join(" "); // Fallback title
    }
  };
  useEffect(() => {
    LOGGER(location.pathname);
    setPageTitle(getPageTitle(location.pathname));
  }, [location]);

  const hideProfilePopover = () => {
    setProfilePopoverOpen(false);
  };
  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  const handleProfilePopoverOpenChange = (newOpen) => {
    setProfilePopoverOpen(newOpen);
  };
  useEffect(() => {
    if (userProfileData) {
      SET_LOCAL_STORAGE(
        LOCAL_STORAGE_KEY.userName,
        userProfileData["userName"]
      );
      SET_LOCAL_STORAGE(
        LOCAL_STORAGE_KEY.userRegion,
        userProfileData?.userRegion
      );

      setUserProfile(userProfileData);
      const filteredRoles = preDefinedRolesJsonList.filter((preRoles) =>
        userProfileData?.roles?.split(",").includes(preRoles.role)
      );
      setFilteredRolesList(filteredRoles);
    }
  }, [userProfileData, setUserProfile]);

  //fetching user role for global usage
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [allPA, allFL, allML] = await Promise.all([
          getUserByRole(PA),
          // getUserByRole(PFA),
          // getUserByRole(CM),
          // getUserByRole(SM),
          getUserByRole(FL),
          getUserByRole(ML),
        ]);

        const roles = { allPA, allFL, allML };
        LOGGER(roles);
        setRolesList(roles);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div className="bg-white py-5 px-9  brd-btm  ">
        {/* <pre>{JSON.stringify(projectInfoZustandState, null, 4)}</pre> */}
        <Row>
          <Col span={12}>
            <Spin spinning={isShowFullLoader} percent={90} fullscreen />

            <Popover
              overlayClassName="pop-over-no-padding"
              content={""}
              title={
                <div>
                  <ul className="switch-role-ul">
                    {/* {filteredRolesList.length && (
                      <li className=" text-red-500 font-semibold text-[12px]">
                        Error!
                      </li>
                    )} */}
                    {filteredRolesList.map((role, index) => (
                      <li
                        key={index}
                        onClick={() => {
                          SET_LOCAL_STORAGE(
                            LOCAL_STORAGE_KEY.selectedRole,
                            role.role
                          );
                          RE_DIRECT_TO(role.path);
                          setIsShowFullLoader(true);
                        }}
                      >
                        <a className="hover:text-blue-900" href={role.path}>
                          {role.title}
                        </a>
                        <small className=" text-[green] text-[16px] ms-1">
                          {GET_LOCAL_STORAGE(LOCAL_STORAGE_KEY.selectedRole) ==
                            role.role && <PiCheckCircleDuotone />}
                        </small>
                      </li>
                    ))}
                  </ul>
                </div>
              }
              trigger="click"
              open={profilePopoverOpen}
              onOpenChange={handleProfilePopoverOpenChange}
            >
              <div className=" cursor-pointer  inline-flex	 items-center font-medium">
                {removeUnderscore(
                  GET_LOCAL_STORAGE(LOCAL_STORAGE_KEY.selectedRole)
                )}
                <MdKeyboardArrowDown size={19} />
              </div>
            </Popover>
          </Col>
          <Col span={12} className=" justify-end flex   items-center">
            <Notification />
            <Link to="/profile" className="flex   items-center">
              <FaCircleUser size={25} color="#0057b8" className="me-1 ms-2" />
              {/* <img
              src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D"
              className="profile-img ms-5 me-2"
            /> */}
              {/* <Popover
            content={<a onClick={hide}>Close</a>}
            title="Title"
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
          >          </Popover> */}
              {isLoading ? "Loading..." : userProfileData?.["userName"]}
            </Link>
          </Col>
        </Row>
      </div>

      <div className="  mx-8 font-medium pt-5 flex items-center capitalize">
        <span
          className={`flex me-1 cursor-pointer ${
            projectInfoData?.projectTitle ? "opacity-50" : ""
          }`}
        >
          <HiOutlineHome size={17} color="#484141" className="me-1 mb-1" />
          {pageTitle}
        </span>
        {projectInfoData?.projectTitle && (
          <>
            <span className=" opacity-50 mx-1">/</span>
            {projectInfoData?.projectTitle}
          </>
        )}
      </div>
    </>
  );
}

export default Navbar;
